<template>

  <b-modal id="listoutputfields"
           :title="title"
           :lazy="true"
           :ok-title = "okTitle"
           @ok="save"
            size="lg"
           @show="showOutPutFiled"
            ok-only>
    <b-row>
      <b-col>
          The fields on the right side of the boxes below will be included in the output of your list order automatically. If you wish to add more fields,
          simply choose the field(s) from the list at the left and click "Add". When your selections have been made click "Save" to continue. Please note
          adding additional fields will increase the price of the list. If you have any questions, you may contact us at 800-399-8611.<br>
      </b-col>
    </b-row>
    <b-row class="select-box">
      <b-col md="5">
        <h4>Available Additional Columns:</h4>
        <b-select v-model="selectcolumn"
                  :select-size="10"
                  class="demo-select"
                  multiple>
          <option v-for="item in outputcol"
                  :value = "item">
            {{item.ColumnDesc}}</option>
        </b-select>
      </b-col>
      <b-col md="2" class="m-select-btn-box">
        <b-btn class="m-select-btn"
               size="sm"
               @click="addColumns()">
          Add</b-btn>
        <b-btn class="m-select-btn"
               size="sm"
               @click="deleteColumns()">
          Remove</b-btn>
        <b-btn class="m-select-btn"
               @click="cleanCloumns()"
               size="sm">
          Remove All</b-btn>
      </b-col>
      <b-col md="5" rows="2">
        <h4>Fields Included:</h4>
        <b-select v-model="unselectcolumn"
                  :select-size="10"
                  class="demo-select"
                  :options="selectedcol"
                  multiple >
        </b-select>
        <!-- TODO@PONY need update-->
      </b-col>
    </b-row>
    <b-row>
      <b-col class="totalprice">
        <p><span class="total-price-label">Total Price: </span>{{order.TotalEstmCost | numberFormat}} + tax</p>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script >
  import utils from '@/assets/utils/index'
  export default {
    components: {
    },
    created () {
    },
    data () {
      return {
        title: 'List Output Fields',
        okTitle: 'OK',
        showError: false,
        selectcolumn: [],
        unselectcolumn: []
      }
    },
    computed: {
      order () {
        return this.$store.state.order
      },
      summary () {
        return this.$store.state.summary
      },
      selectedcol () {
        return this.$store.state.summary.SelectCols
      },
      outputcol () {
        return this.$store.state.summary.ListOutputFields
      }
    },
    methods: {
      addColumns () {
        for (let item of this.selectcolumn) {
          this.$store.commit('summary/saveSelectedCols', { text: item.ColumnDesc, value: item.ColumnName, disabled: false })
        }
        this.saveorder()
      },
      cleanCloumns () {
        this.$store.commit('summary/clearCols')
        this.saveorder()
      },
      deleteColumns () {
        for (let item of this.unselectcolumn) {
          this.$store.commit('summary/deleteCols', item)
        }
        this.saveorder()
      },
      saveorder () {
        let cols = []
        for (let i in this.selectedcol) {
          if (!this.selectedcol[i].disabled) {
            cols.push(this.selectedcol[i])
          }
        }
        let oldelements = this.$store.state.order.ElementsForPricing
        let olds = []
        for (let item in oldelements) {
          if (!oldelements[item].IsAdditional) {
            olds.push(oldelements[item])
          }
        }
        this.$store.commit('order/clearElementsForPricing')
        this.$store.commit('order/saveAdditionalOutputColumns', '')
        for (let item in olds) {
          this.$store.commit('order/addElementsForPricing', olds[item])
        }
        let colums = ''
        for (let i in cols) {
          let price
          for (let j in this.outputcol) {
            if (this.outputcol[j].ColumnName === cols[i].value) {
              price = this.outputcol[j]
              colums = colums + price.ColumnName + ','
              var pricecol
              if (price.IsSubElement) {
                pricecol = {
                  ElementName: price.ParentColumnName,
                  IsAdditional: true,
                  Price: price.ColumnPrice,
                  SubColumnName: price.ColumnName
                }
              } else {
                pricecol = {
                  ElementName: price.ColumnName,
                  IsAdditional: true,
                  Price: price.ColumnPrice
                }
              }
              this.$store.commit('order/addElementsForPricing', pricecol)
            }
          }
        }
        if (colums.length > 0) {
          colums = colums.substring(0, colums.length - 1)
        }
        this.$store.commit('order/saveAdditionalOutputColumns', colums)
        this.$store.dispatch('order/calculatePrice')
      },
      getoutputcolumns () {
        let selectedDemo = ''
        let that = this
        for (let item of this.order.OrderSelectedDemos) {
          selectedDemo = selectedDemo + item.ColumnName + ','
        }
        selectedDemo = selectedDemo.substr(0, selectedDemo.length - 1)
        this.$http.post('PlaceOrder.aspx/GetAdditionalOutputColumnsAndPrice', {
          selectedQty: that.order.TotalDesiredQty,
          priceListId: this.summary.UserPriceList.PriceListId,
          currentSelectedCols: that.order.AdditionalOutputColumns,
          selectedDemo: selectedDemo
        }).then(resp => {
          let arrdefault = resp.body.d.DataSource.DefaultOutputList.split(',').reverse()
          for (let item in arrdefault) {
            var field = ''
            if (arrdefault[item] === 'DSFDeliv') {
              field = { text: 'DSF Delivery Score', value: arrdefault[item], disabled: true }
            } else if (arrdefault[item] === 'DSFWALK') {
              field = { text: 'DSF Walk Sequence', value: arrdefault[item], disabled: true }
            } else {
              field = { text: arrdefault[item], value: arrdefault[item], disabled: true }
            }
            this.$store.commit('summary/saveSelectedCols', field)
          }
          var list = resp.body.d.DataSource.AdditionalOutputColumns
          utils.sortJson(list, 'ColumnDesc', 'asc')
          this.$store.commit('summary/saveListOutputFields', list)
        })
      },
      save () {
      },
      showOutPutFiled () {
        if (this.$store.state.summary.SelectCols.length === 0 || this.$store.state.summary.ListOutputFields.length === 0) {
          this.getoutputcolumns()
        }
      }
    },
    mounted () {
    }
  }
</script>

<style scoped lang="scss">
  .totalprice{
    margin-top: 8px;
    text-align: right;
  }

  .select-box {
    margin-top: 32px;
  }

  .total-price-label{
    color: $color-primary;
  }
</style>



// WEBPACK FOOTER //
// src/components/summary/MListOutputFields.vue